import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {setNewPassword} from '../actions';
import Link from 'react-router-dom/Link';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import {MIN_PASSWORD_STRENGTH} from '../../Auth/passwordConfig';
import validator from 'validator';
import zxcvbn from 'zxcvbn';
import classnames from "classnames";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_set_new_password';

class SetNewPasswordForm extends Component {
    state = {
        errors: {},
        password: '',
        password_confirmation: '',
        password_strength_score: null,
        password_strength_note: '',
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
            });
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
        }, () => this.validateFieldsAndDisplayErrors([name]));
    };

    handleSubmit = e => {
        e.preventDefault();

        const key = this.props.match.params.key;
        const idUser = this.props.match.params.user;

        this.props.setNewPassword(key, idUser, this.state.password, this.state.password_confirmation);
    };

    validateFieldsAndDisplayErrors = (fields = []) => {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        let hasErrors = false;

        for (let i = 0, len = fields.length; i < len; i++) {
            let error = this.validateField(fields[i]);

            if (error !== null) {
                hasErrors = true;
            }

            errorsData[fields[i]] = error;
        }

        this.setState({
            errors: {
                ...errors,
                data: errorsData,
            }
        });

        return hasErrors;
    };

    validateField = (field) => {
        let error = null;

        switch (field) {
            case 'password':
                if (validator.isEmpty(this.state.password)) {
                    error = this.props.translate('auth_set_new_password.error_password_required');
                } else {
                    let note = '';
                    const strength = zxcvbn(this.state.password, []); // TODO : get user first name, last name and email address

                    if (strength.score < MIN_PASSWORD_STRENGTH) {
                        error = this.props.translate('auth_set_new_password.error_stronger_password');
                    }

                    switch (strength.score) {
                        case 0:
                        case 1:
                            note = this.props.translate('auth_set_new_password.error_password_strength_weak');
                            break;
                        case 2:
                            note = this.props.translate('auth_set_new_password.error_password_strength_soso');
                            break;
                        case 3:
                            note = this.props.translate('auth_set_new_password.error_password_strength_good');
                            break;
                        case 4:
                            note = this.props.translate('auth_set_new_password.error_password_strength_great');
                            break;
                        default:
                            break;
                    }

                    this.setState({
                        password_strength_score: strength.score,
                        password_strength_note: note,
                    });
                }
                break;
            case 'password_confirmation':
                if (validator.isEmpty(this.state.password_confirmation)) {
                    error = this.props.translate('auth_set_new_password.error_confirmation_password_required');
                } else {
                    if (!validator.equals(this.state.password, this.state.password_confirmation)) {
                        error = this.props.translate('auth_set_new_password.error_confirmation_password_match');
                    }
                }
                break;
            default:
                break;
        }

        return error;
    };

    render() {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        const {setNewPasswordLoading, setNewPasswordSuccess} = this.props.auth;
        const {password_strength_score, password_strength_note} = this.state;

        if (setNewPasswordSuccess && !setNewPasswordLoading) {
            return (
                <div className="row row-thanks">
                    <div className="col col-9">
                        <h3><Translate id="auth_set_new_password.success_title" /></h3>
                        <Translate id="auth_set_new_password.success_description" />
                        <Button variant="contained" color="primary" className="btn" component={props => <Link to="/" {...props}/>}>
                            <Translate id="auth_set_new_password.button_back_home" />
                        </Button>
                    </div>
                </div>
            )
        }

        return (
            <Fragment>
                <form autoComplete="off" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col col-6">
                            <FormControl className={classnames('form-control form-control-password', 'strength-' + password_strength_score, {'has-error': errorsData.password ? true : false})} fullWidth={true} margin="normal" error={errorsData.password ? true : false}>
                                <InputLabel htmlFor="password" className="form-label"><Translate id="auth_set_new_password.field_new_password" /> *</InputLabel>
                                <Input id="password" value={this.state.password} onChange={this.handleChange('password')} className="form-input" type="password" />
                                {errorsData.password && (<FormHelperText className="form-helper">{errorsData.password}</FormHelperText>)}
                                {(password_strength_note !== '' && this.state.password !== '') && <span className="password-strength-note">Force : {password_strength_note}</span>}
                            </FormControl>

                            <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.password_confirmation ? true : false}>
                                <InputLabel htmlFor="password_confirmation" className="form-label"><Translate id="auth_set_new_password.field_password_confirmation" /> *</InputLabel>
                                <Input id="password_confirmation" value={this.state.password_confirmation} onChange={this.handleChange('password_confirmation')} className="form-input" type="password" />
                                {errorsData.password_confirmation && (<FormHelperText className="form-helper">{errorsData.password_confirmation}</FormHelperText>)}
                            </FormControl>
                        </div>
                        <div className="col col-6"></div>
                    </div>
                    {setNewPasswordLoading ? (
                        <div className="row row-loading mt-50">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row mt-50">
                            <div className="col col-9">
                                <Typography variant="caption" className="mb-10">
                                    * <Translate id="auth_set_new_password.mandatory_fields" />
                                </Typography>
                                <Button variant="contained" color="primary" size="large" className="btn-submit" type="submit">
                                    <Translate id="auth_set_new_password.button_submit" />
                                </Button>
                            </div>
                        </div>
                    )}
                </form>
            </Fragment>
        );
    }
}

SetNewPasswordForm.propTypes = {
    setNewPassword: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.auth.setNewPasswordErrors,
});

export default withRouter(connect(mapStateToProps, {setNewPassword})(withLocalize(SetNewPasswordForm)));


// WEBPACK FOOTER //
// ./src/features/Auth/components/SetNewPasswordForm.js